import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import TBody from '../common/table/tBody';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import Td from '../common/table/td';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { setError } from '../common/toast/toast';

import { setModoTela, initForm, getListaProducoes } from './cargaActions';

const somenteData = valor => (valor || '').split('T')[0].split(' ')[0].replace(/\//g, '-');

class CargaForm extends Component {

	ordenarProducoes(lista) {
		return [...(lista || [])].sort((a, b) => {
			const ordemA = a.ordem == null ? Number.MAX_SAFE_INTEGER : Number(a.ordem);
			const ordemB = b.ordem == null ? Number.MAX_SAFE_INTEGER : Number(b.ordem);

			if (ordemA !== ordemB) {
				return ordemA - ordemB;
			}

			return Number(a.id) - Number(b.id);
		});
	}

	producoesDoDia() {
		const formulario = this.props.formularioValues || {};
		const dataCarga = somenteData(formulario.data_agendamento);

		return this.ordenarProducoes((this.props.listaProducoes || []).filter(item => (
			somenteData(item.data_agendamento) === dataCarga
		)));
	}

	idCargaDaProducao(idProducao) {
		const carga = (this.props.listaCargas || []).find(item => (
			(item.producoes || []).some(producao => (
				String(producao.id_producao) === String(idProducao)
			))
		));

		return carga ? carga.id : null;
	}

	selecionarProducao(producao) {
		if (!this.props.permitirAlterarProducoes) {
			return;
		}

		const formulario = this.props.formularioValues || {};
		const producoesDia = this.producoesDoDia();
		const selecionadas = formulario.producoes || [];
		const selecionada = selecionadas.some(item => (
			String(item.id_producao) === String(producao.id)
		));
		const idCargaProducao = this.idCargaDaProducao(producao.id);

		if (idCargaProducao && String(idCargaProducao) !== String(formulario.id)) {
			setError(`A produção ${producao.id} já pertence à carga ${idCargaProducao}.`);
			return;
		}

		let novosIds = selecionadas.map(item => String(item.id_producao));

		if (selecionada) {
			novosIds = novosIds.filter(id => id !== String(producao.id));
		} else {
			novosIds.push(String(producao.id));
		}

		const posicoes = novosIds.map(id => (
			producoesDia.findIndex(item => String(item.id) === id)
		)).sort((a, b) => a - b);

		const sequenciais = posicoes.every((posicao, indice) => (
			posicao >= 0 && (indice === 0 || posicao === posicoes[indice - 1] + 1)
		));

		if (!sequenciais) {
			setError('Selecione apenas produções consecutivas na ordem do dia.');
			return;
		}

		const producoes = producoesDia
			.filter(item => novosIds.includes(String(item.id)))
			.map(item => ({
				id_producao: item.id,
				ordem: item.ordem
			}));

		this.props.initForm({
			...formulario,
			producoes
		});
	}

	renderProducoes() {
		const formulario = this.props.formularioValues || {};
		const todasProducoes = this.producoesDoDia();
		const selecionadas = (formulario.producoes || []).map(item => String(item.id_producao));
		const composicaoBloqueada = this.props.excluir
			|| !this.props.permitirAlterarProducoes
			|| (
				!!formulario.id
				&& formulario.status_producao
				&& formulario.status_producao !== 'NAO_INICIADA'
			);
		const producoes = this.props.permitirAlterarProducoes
			? todasProducoes
			: todasProducoes.filter(item => selecionadas.includes(String(item.id)));

		if (!formulario.data_agendamento) {
			return (
				<div className='alert alert-info' style={{ marginBottom: 0 }}>
					Informe a data para carregar as produções programadas do dia.
				</div>
			);
		}

		if (!producoes.length) {
			return (
				<div className='alert alert-warning' style={{ marginBottom: 0 }}>
					Nenhuma produção encontrada para a data selecionada.
				</div>
			);
		}

		return (
			<Table responsive border striped maxHeight={360}>
				<THead>
					<Tr>
						<Th sticky alignCenter width={45}>Carga</Th>
						<Th sticky alignCenter width={65}>Ordem</Th>
						<Th sticky alignCenter width={80}>Produção</Th>
						<Th sticky alignCenter width={90}>Solicitação</Th>
						<Th sticky>Parceiro</Th>
						<Th sticky>Ração</Th>
						<Th sticky alignCenter width={120}>Quantidade</Th>
						<Th sticky alignCenter width={100}>Situação</Th>
					</Tr>
				</THead>
				<TBody>
					{producoes.map((item, indice) => {
						const selecionada = selecionadas.includes(String(item.id));
						const idCarga = this.idCargaDaProducao(item.id);
						const pertenceOutraCarga = idCarga && String(idCarga) !== String(formulario.id);
						const desabilitada = composicaoBloqueada || pertenceOutraCarga;

						return (
							<Tr key={item.id} backgroundColor={selecionada ? '#d9f2df' : null}>
								<Td alignCenter>
									<input
										type='checkbox'
										checked={selecionada}
										disabled={desabilitada}
										onChange={() => this.selecionarProducao(item)} />
								</Td>
								<Td alignCenter>{item.ordem == null ? indice + 1 : item.ordem}</Td>
								<Td alignCenter>{item.id}</Td>
								<Td alignCenter>{item.id_solicitacao}</Td>
								<Td>{item.nome_parceiro}</Td>
								<Td>{item.nome_racao}</Td>
								<Td alignCenter>
									{FormatUtils.formatarValorTela(item.quantidade, 2)} {item.sigla_unidade_medida}
								</Td>
								<Td alignCenter>
									{pertenceOutraCarga
										? `Carga ${idCarga}`
										: (item.datahora_fim ? 'Finalizada' : 'Programada')}
								</Td>
							</Tr>
						);
					})}
				</TBody>
			</Table>
		);
	}

	render() {
		const formulario = this.props.formularioValues || {};
		const readOnly = this.props.excluir ? 'readOnly' : '';
		const producaoCargaIniciada = !!formulario.id
			&& formulario.status_producao
			&& formulario.status_producao !== 'NAO_INICIADA';
		const cancelarPorFaltaDeProducoes = !!formulario.id && !(formulario.producoes || []).length;

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<LabelAndInputDate
								label='Data da carga *'
								cols='12 4 3 3'
								readOnly={readOnly || (producaoCargaIniciada ? 'readOnly' : '')}
								value={formulario.data_agendamento}
								onChange={value => {
									this.props.initForm({
										...formulario,
										data_agendamento: value,
										producoes: this.props.permitirAlterarProducoes ? [] : formulario.producoes
									});
									this.props.getListaProducoes(value);
								}} />

							<Select
								name='id_veiculo'
								options={this.props.listaVeiculo}
								label='Veículo *'
								placeholder='Informe'
								cols='12 4 4 4'
								readOnly={readOnly}
								value={formulario.id_veiculo}
								onChange={value => this.props.initForm({
									...formulario,
									id_veiculo: value
								})} />

							<Select
								name='id_motorista'
								options={this.props.listaMotorista}
								label='Motorista *'
								placeholder='Informe'
								cols='12 4 5 5'
								readOnly={readOnly}
								value={formulario.id_motorista}
								onChange={value => this.props.initForm({
									...formulario,
									id_motorista: value
								})} />
						</Row>

						<Row>
							{!this.props.ocultarInicioFim &&
							<LabelAndInputDateTime
								label='Início da carga'
								cols='12 4 3 3'
								readOnly={readOnly}
								value={formulario.datahora_inicio}
								onChange={value => this.props.initForm({
									...formulario,
									datahora_inicio: value
								})} />}

							{!this.props.ocultarInicioFim &&
							<LabelAndInputDateTime
								label='Fim da carga'
								cols='12 4 3 3'
								readOnly={readOnly}
								value={formulario.datahora_fim}
								onChange={value => this.props.initForm({
									...formulario,
									datahora_fim: value
								})} />}

							<Field
								name='observacao'
								component={LabelAndTextarea}
								label='Observação'
								placeholder='Informe'
								rows={2}
								cols='12 12 6 6'
								readOnly={readOnly || (!this.props.permitirAlterarProducoes ? 'readOnly' : '')} />
						</Row>

						<Row>
							<Grid cols='12'>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
									<label style={{ marginBottom: 0 }}>Produções da carga *</label>
									<span className='badge badge-primary'>
										{(formulario.producoes || []).length} selecionada(s)
									</span>
								</div>
								{!this.props.permitirAlterarProducoes && !this.props.excluir &&
								<div className='alert alert-info' style={{ padding: 8 }}>
									As produções desta carga são definidas somente na tela Programar Produção. Aqui você pode alterar veículo, motorista e datas.
								</div>}
								{this.props.permitirAlterarProducoes && producaoCargaIniciada && !this.props.excluir &&
								<div className='alert alert-info' style={{ padding: 8 }}>
									A produção da carga já foi iniciada. As produções e a data estão bloqueadas, mas veículo e motorista podem ser substituídos.
								</div>}
								{cancelarPorFaltaDeProducoes && !this.props.excluir &&
								<div className='alert alert-warning' style={{ padding: 8 }}>
									Todas as produções foram removidas. Ao confirmar, esta carga será cancelada automaticamente.
								</div>}
								{this.renderProducoes()}
							</Grid>
						</Row>
					</ContentCardBody>

					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button text='Excluir' submit type='danger' />
								) : (
									<Button
										text={cancelarPorFaltaDeProducoes ? 'Cancelar carga' : 'Salvar'}
										submit
										type={cancelarPorFaltaDeProducoes ? 'danger' : 'success'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type='warning'
									event={() => {
										if (this.props.onVoltar) {
											this.props.onVoltar();
										} else {
											this.props.setModoTela('lista');
										}
									}} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
	}
}

CargaForm = reduxForm({ form: 'cargaForm', destroyOnUnmount: false })(CargaForm);

const mapStateToProps = state => ({
	formularioValues: getFormValues('cargaForm')(state) || {},
	listaVeiculo: state.veiculo.listaSelect,
	listaMotorista: state.motorista.listaSelect,
	listaProducoes: state.carga.listaProducoes,
	listaCargas: state.carga.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela,
	initForm,
	getListaProducoes
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CargaForm);
